import type { CmpHider } from './types';

export const klaro: CmpHider = {
  id: 'klaro',
  label: 'Klaro!',
  css: `
      /* Klaro! (kiprotect.com/klaro, heyklaro.com): the consent UI lives inside a
         top-level wrapper "div.klaro" which holds the first-visit banner
         (".klaro .cookie-notice", id "klaro-cookie-notice", position:fixed,
         z-index 999), the preferences modal (".klaro .cookie-modal",
         position:fixed full-viewport, z-index 1000) whose inner dialog is
         ".cm-modal" and whose dimming backdrop is ".cm-bg" (position:fixed,
         bg rgba(0,0,0,0.5)), and the per-service "context-notice" placeholder
         (".klaro .context-notice"). Klaro uses generic class names
         (".cookie-modal", ".cookie-notice", ".cm-*") shared by other libraries,
         so every rule is SCOPED under the ".klaro" ancestor to avoid hitting
         unrelated page elements. The ".cm-bg" backdrop is a child of
         ".cookie-modal", so hiding the modal removes the dimmer in one go.
         Klaro does NOT lock page scroll (no body/html class or inline overflow
         is set when the notice/modal is open), so no scroll-lock release is
         needed here. No backticks anywhere in this block — it is a JS template
         literal. */
      .klaro .cookie-notice,
      .klaro .cookie-modal,
      .klaro .context-notice { display: none !important; }
  `,
};
